import { configure } from "vue-gtag";
import Clarity from "@microsoft/clarity";
import { getUtmParams } from "@repo/ui";
import type { OnCreateAppSync } from "vike-vue/types";

import { sentryBrowserConfig } from "../sentry.browser.config";

export const onCreateApp: OnCreateAppSync = (pageContext): ReturnType<OnCreateAppSync> => {
  //https://matteo-gabriele.gitbook.io/vue-gtag
  configure({
    tagId: import.meta.env.PUBLIC_ENV__GOOGLE_ANALYTICS,
  })

  const clarityProjectId = import.meta.env.PUBLIC_ENV__CLARITY_PROJECT_ID
  if (clarityProjectId) {
    Clarity.init(clarityProjectId)
    for (const [key, value] of Object.entries(getUtmParams(pageContext))) {
      if (value) Clarity.setTag(key, value)
    }
  }

  const { app } = pageContext;
  sentryBrowserConfig(app)
}
